export const getTopSuccess = (data) => ({
	type: 'GET_TOP_SUCCESS',
	data,
});

export const getTopError = () => ({
	type: 'GET_TOP_ERROR'
});

export const getGoodsSuccess = (data) => ({
	type: 'GET_GOODS_SUCCESS',
	data,
});

export const getGoodsError = () => ({
	type: 'GET_GOODS_ERROR'
});

export const getCdSuccess = (data) => ({
	type: 'GET_CD_SUCCESS',
	data,
});

export const getCdError = () => ({
	type: 'GET_CD_ERROR'
});

export const getStorySuccess = (data) => ({
	type: 'GET_STORY_SUCCESS',
	data,
});

export const getStoryError = () => ({
	type: 'GET_STORY_ERROR'
});

export const getHeaderSuccess = (data) => ({
	type: 'GET_HEADER_SUCCESS',
	data,
});

export const getHeaderError = () => ({
	type: 'GET_HEADER_ERROR'
});



// WEBPACK FOOTER //
// src/actions/index.js